<div class="card-container-shadow">
  <p class="modified new" *ngIf="pdfTemplate.createdAt | itsNewTemplate">Nuevo</p>
  <div class="tw-relative container-cover">
    <img class="cover-image" loading="lazy" [src]="pdfTemplate.media[0]?.key || '../../../assets/images/templates/tpl5.png'" alt="">
    <div class="preview-img" (click)="onPreview()">
      <img src="../../../assets/images/icons/icons8-image-53.png" alt="">
      <p class="tw-whitespace-nowrap tw-text-white tw-font-medium">Clic para ver más imágenes</p>
    </div>
    <p class="heart" [class.always-show]="selected">
      <span nz-icon nzType="heart" [nzTheme]="selected ? 'fill' : 'outline'"></span>
    </p>
  </div>
  <div class="tpl-info tw-mt-3">
    <p class="tw-text-gray-600 tw-text-lg tw-font-medium truncate"
       nz-popover="" nzPopoverTitle="" [nzPopoverContent]="pdfTemplate.name.length > 25 ? pdfTemplate.name : ''"
    >
      {{pdfTemplate.name}}
    </p>
    <p class="tw-text-gray-400 tw-italic tw-font-light tw-text-xs">por {{pdfTemplate.author}} <span class="tw-text-orange-500 tw-ml-1 tw-not-italic">v{{pdfTemplate.version}}</span></p>

    <div class="tw-flex tw-justify-between tw-items-baseline tw-mt-4">
      <div class="tw-flex tw-flex-col">
        <nz-rate [(ngModel)]="pdfTemplate.rating" [nzTooltips]="tooltipsScore" class=""></nz-rate>
        <p class="tw-text-xs tw-text-gray-400 tw-font-medium">Adquirido <span class="tw-text-gray-600">{{pdfTemplate.unitsSold}} veces</span></p>
      </div>
      <div class="tw-flex tw-items-center">
        <p class="price">{{pdfTemplate.cost > 0 ? (pdfTemplate.cost | currency) : 'gratis'}}</p>
        <!--<p class="old-price">$90</p>-->
      </div>
    </div>

    <div class="section-actions tw-mt-4 tw-flex tw-justify-end tw-items-center">
      <button nz-button nzType="primary" (click)="onSelect()" class="btn-small">Seleccionar</button>
    </div>
  </div>
</div>
